import Vue from 'vue';
// import * as Qiniu from 'qiniu-js';
// import nanoid from 'nanoid';

Vue.directive('cxselect', {
    bind: function (el, bind, vnode) {
        // @ts-ignore
        $.cxSelect.defaults.nodata = 'none';
        // @ts-ignore
        $(el).cxSelect({
            selects: ['province', 'city', 'regionId'],  // 数组格式，请注意顺序
            jsonName: 'name_zh',
            jsonValue: 'id',
            jsonSub: 'child',
            url: '/regionsList'
        });
        // @ts-ignore
        $(el).find('select').click(function () {
            let value = '';
            if ($(el).find('select').length === 3) {
                let region = $(el).find('select:eq(2)')[0] as HTMLSelectElement;
                if (region && region.selectedIndex > 0) {
                    value = region.options[region.selectedIndex].value;
                }
            }
            // @ts-ignore
            Vue.set(vnode.context.data, 'regionId', value);
        });
    },
    update: function (value) {
    },
    unbind: function () {
    }
});
Vue.directive('timeselect', {
    bind: function (el, bind, vnode) {
        let initDate = new Date();
        initDate.setHours(0, 0, 0, 0);
        let optionsObj = {
            autoclose: true,
            isRTL: false,
            format: 'yyyy-mm-dd 00:00:00',
            pickerPosition: ('bottom-left'),
            language: 'zh-CN',
            weekStart: 1,
            // startDate: new Date(),
            minView: 2,
            todayHighlight: true,
            initialDate: initDate
        };
        let expression = bind.expression ? bind.expression.split('.') : [];
        ($(el) as any).datetimepicker(optionsObj).on('changeDate', function (ev: any) {
            ev.date.setHours(0, 0, 0, 0);
            if (expression.length > 1) {
                // @ts-ignore
                Vue.set(vnode.context[expression[0]], expression[1], $(el)[0].value);
            }
        });
    },
    update: function (value) {
    },
    unbind: function () {
    }
});
Vue.directive('timeselectValue', {
    bind: function (el, bind, vnode) {
        let initDate = new Date();
        initDate.setHours(0, 0, 0, 0);
        let optionsObj = {
            autoclose: true,
            isRTL: false,
            format: 'yyyy-mm-dd 00:00:00',
            pickerPosition: ('bottom-left'),
            language: 'zh-CN',
            weekStart: 1,
            // startDate: new Date(),
            minView: 2,
            todayHighlight: true,
            initialDate: initDate
        };
        // @ts-ignore
        $(el).datetimepicker(optionsObj).on('changeDate', function (ev) {
            ev.date.setHours(0, 0, 0, 0);
            // @ts-ignore
            let name = vnode.context[bind.value[0]];
            if (bind.value.length > 2) {
                for (let i = 1; i < bind.value.length - 1; i++) {
                    name = name[bind.value[i]];
                }
            }
            Vue.set(name, bind.value[bind.value.length - 1], ($(el)[0] as HTMLInputElement).value);
        });
    },
    update: function (value) {
    },
    unbind: function () {
    }
});
Vue.directive('qiniuupload', {
    bind: function (el, bind, vnode) {
//         let expression = bind.expression.split('.');
//         let optionsObj = {
//             runtimes: 'html5,flash,html4',    //上传模式,依次退化
//             browse_button: el,       //上传选择的点选按钮，**必需**
//             uptoken_url: '/token',            //Ajax请求upToken的Url，**强烈建议设置**（服务端提供）
// //                    uptoken : '<%=token%>', //若未指定uptoken_url,则必须指定 uptoken ,uptoken由其他程序生成
//             // unique_names: true, // 默认 false，key为文件名。若开启该选项，SDK为自动生成上传成功后的key（文件名）。
//             // save_key: true,   // 默认 false。若在服务端生成uptoken的上传策略中指定了 `sava_key`，则开启，SDK会忽略对key的处理
//             domain: 'http://dizhi/',   //bucket 域名，下载资源时用到，**必需**
//             container: expression[expression.length - 1],           //上传区域DOM ID，默认是browser_button的父元素，
//             max_file_size: '100mb',           //最大文件体积限制
//             flash_swf_url: 'js/plupload/Moxie.swf',  //引入flash,相对路径
//             max_retries: 3,                   //上传失败最大重试次数
//             // dragdrop: true,                   //开启可拖曳上传
//             multi_selection: true, //设置每次只能选择一个文件
//             // drop_element: 'container',        //拖曳上传区域元素的ID，拖曳文件或文件夹后可触发上传
//             chunk_size: '4mb',                //分块上传时，每片的体积
//             auto_start: true,
//             init: {
//                 'FileUploaded': function (up: any, file: any, info: any) {
//                     // 每个文件上传成功后,处理相关的事情
//                     // 其中 info.response 是文件上传成功后，服务端返回的json，形式如
//                     // {
//                     //    "hash": "Fh8xVqod2MQ1mocfI4S4KpRL6D98",
//                     //    "key": "gogopher.jpg"
//                     //  }
//                     // 参考http://developer.qiniu.com/docs/v6/api/overview/up/response/simple-response.html
//                     let domain = up.getOption('domain');
//                     info = JSON.parse(info);
//                     let sourceLink = domain + info.key; //获取上传成功后的文件的Url
//                     // @ts-ignore
//                     Vue.set(vnode.context[expression[0]], expression[expression.length - 1], sourceLink);
//                 },
//                 'Error': function (up:any, err: any, errTip: any) {
//                     //上传出错时,处理相关的事情
//                 },
//                 'UploadComplete': function () {
//                     //队列文件处理完毕后,处理相关的事情
//                 },
//                 'Key': function (up: any, file: any) {
//                     // 若想在前端对每个文件的key进行个性化处理，可以配置该函数
//                     // 该配置必须要在 unique_names: false , save_key: false 时才生效
//                     let fileSuffix = '';
//                     let name = file.name.split('.');
//                     if (name.length > 1) {
//                         fileSuffix = '.' + name[name.length - 1];
//                     }
//                     let key = nanoid() + fileSuffix;
//                     return key;
//                 }
//             }
//         };
//         Qiniu.upload(optionsObj);
    }
});
Vue.directive('qiniuuploadObj', {
    bind: function (el, bind, vnode) {
//         let expression = bind.expression.split('.');
//         let optionsObj = {
//             runtimes: 'html5,flash,html4',    //上传模式,依次退化
//             browse_button: el,       //上传选择的点选按钮，**必需**
//             uptoken_url: '/token',            //Ajax请求upToken的Url，**强烈建议设置**（服务端提供）
// //                    uptoken : '<%=token%>', //若未指定uptoken_url,则必须指定 uptoken ,uptoken由其他程序生成
//             // unique_names: true, // 默认 false，key为文件名。若开启该选项，SDK为自动生成上传成功后的key（文件名）。
//             // save_key: true,   // 默认 false。若在服务端生成uptoken的上传策略中指定了 `sava_key`，则开启，SDK会忽略对key的处理
//             domain: 'http://cachedizhi/',   //bucket 域名，下载资源时用到，**必需**
//             container: expression[expression.length - 1],           //上传区域DOM ID，默认是browser_button的父元素，
//             max_file_size: '100mb',           //最大文件体积限制
//             flash_swf_url: 'js/plupload/Moxie.swf',  //引入flash,相对路径
//             max_retries: 3,                   //上传失败最大重试次数
//             // dragdrop: true,                   //开启可拖曳上传
//             multi_selection: true, //设置每次只能选择一个文件
//             // drop_element: 'container',        //拖曳上传区域元素的ID，拖曳文件或文件夹后可触发上传
//             chunk_size: '4mb',                //分块上传时，每片的体积
//             auto_start: true,
//             init: {
//                 'FileUploaded': function (up, file, info) {
//                     // 每个文件上传成功后,处理相关的事情
//                     // 其中 info.response 是文件上传成功后，服务端返回的json，形式如
//                     // {
//                     //    "hash": "Fh8xVqod2MQ1mocfI4S4KpRL6D98",
//                     //    "key": "gogopher.jpg"
//                     //  }
//                     // 参考http://developer.qiniu.com/docs/v6/api/overview/up/response/simple-response.html
//                     let domain = up.getOption('domain');
//                     info = JSON.parse(info);
//                     let sourceLink = domain + info.key; //获取上传成功后的文件的Url
//                     Vue.set(vnode.context[expression[0]], expression[expression.length - 1], {
//                         url: sourceLink,
//                         name: file.name
//                     });
//                 },
//                 // @ts-ignore
//                 'Error': function (up, err, errTip) {
//                     //上传出错时,处理相关的事情
//                 },
//                 'UploadComplete': function () {
//                     //队列文件处理完毕后,处理相关的事情
//                 },
//                 'Key': function (up, file) {
//                     // 若想在前端对每个文件的key进行个性化处理，可以配置该函数
//                     // 该配置必须要在 unique_names: false , save_key: false 时才生效
//                     let fileSuffix = '';
//                     let name = file.name.split('.');
//                     if (name.length > 1) {
//                         fileSuffix = '.' + name[name.length - 1];
//                     }
//                     let key = nanoid() + fileSuffix;
//                     return key;
//                 }
//             }
//         };
//         Qiniu.uploader(optionsObj);
    }
});
export default Vue;
